module.exports = __webpack_public_path__ + "img/hr-H-T-3-unload-connect-shadow.24a97003.png";